import React, { Component } from 'react'
import CurrencyFormat from 'react-currency-format';

export default class Results extends Component {

  render() {

    let { amount, years, months, deposit, savings } = this.props;

    let totalMonths = (+years * 12) + (+months);

    let amountWithDeposit = amount / 100 * deposit;
    let amountMinusSavings = amountWithDeposit - savings;

    let amountToSaveEachMonth = 0

    if (totalMonths > 0) {
      amountToSaveEachMonth = amountMinusSavings / totalMonths;
      if (amountToSaveEachMonth < 0) {
        amountToSaveEachMonth = 0
      }
    } else {
      amountToSaveEachMonth = amountMinusSavings;
      if (amountToSaveEachMonth < 0) {
        amountToSaveEachMonth = 0
      }
    }

    var monthText = totalMonths <= 1 ? ' this month' : ' each month';

    const gtmConfig = 'https://www.principality.co.uk';

    const gtmSend = (eventLabel, value) => {
      window.parent.postMessage('event~MortgageDepositCalculator~6_' + eventLabel + '~' + value, gtmConfig);
    }

    return (
      <div className="results">
        <div className="results-inner">
          <h2 className="results-title">

            {amountMinusSavings <= 0.1 &&
              <div className="results-positive"><span>Congratulations!</span> You have enough saved to buy!</div>
            }

            <div>You need to save&nbsp;
              <CurrencyFormat
                onChange={gtmSend('amountToSaveEachMonth', amountToSaveEachMonth.toFixed(2))}
                value={amountToSaveEachMonth.toFixed(2)}
                displayType={'text'}
                thousandSeparator={true}
                prefix={'£'} />
              {totalMonths > 0 && monthText}
            </div>

          </h2>
        </div>
      </div >
    );
  }
}